




























import FieldModel from '@/UI/Shared/Mixins/FieldModel'
import mixins from 'vue-typed-mixins'

export default mixins(FieldModel).extend({
  name: 'SimpleInput',
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: '',
      validator: (value: string): boolean => {
        return ['', 'danger', 'success', 'warning'].indexOf(value) !== -1
      }
    },
    classes: {
      type: String,
      required: false
    }
  },
  computed: {
    iconClass (): string {
      if (this.disabled) {
        return ''
      }
      if (this.status === 'success') {
        return 'glyphicon-ok'
      }
      if (this.status === 'warning') {
        return 'glyphicon-warning-icon'
      }
      if (this.status === 'danger') {
        return 'glyphicon-remove'
      }
      return ''
    },
    statusMessage (): string {
      if (this.disabled && this.status === '') {
        return ''
      }
      return this.$t('shared.input.message.' + this.status).toString()
    },
    statusClass (): string {
      if (this.disabled) {
        return ''
      }
      if (this.status === 'success') {
        return 'has-success has-feedback'
      }
      if (this.status === 'warning') {
        return 'has-warning has-feedback'
      }
      if (this.status === 'danger') {
        return 'has-error has-feedback'
      }
      return ''
    }
  }
})
